import {
  MagnifyingGlassIcon,
  ChevronUpDownIcon,
} from "@heroicons/react/24/outline";
import { Select, Option } from "@material-tailwind/react";
import ReactJson from "react-json-view";
import _ from "lodash"; // Import Lodash
import { DialogContent, DialogTitle } from "@mui/material";
import PolicyIcon from "@mui/icons-material/Policy";
import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import InfoIcon from "@mui/icons-material/Info";
import ManageAccountsSharpIcon from "@mui/icons-material/ManageAccountsSharp";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardHeader,
  Typography,
  Input,
  Dialog,
  TabsHeader,
  Chip,
  CardBody,
  Tooltip,
  IconButton,
  Button,
  Tabs,
  Tab,
  TabsBody,
  TabPanel,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";

import { getInventoryAwsData } from "../../helperFunctions/apiFunction";
import { useAuthUserToken } from "../../hooks/useAuthUserToken";
import TableSkeleton from "../../components/Loaders/TableSkeleton";
import toast from "react-hot-toast";

const TABLE_HEAD = ["Account Id", "Type", "Key", "Region", "Policies"];
const LAMBDA_TABLE_HEAD = ["Account Id", "Type", "Region", "Policies"];

export default function ComputeAWSApplicationData() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("AWSEC2");
  const { refreshToken } = useAuthUserToken();
  const [templateData, setTemplateData] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [type, setType] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  const [searchBy, setSearchBy] = useState("");
  const [sortBy, setSortBy] = useState("asc");
  const [jsonData, setJsonData] = useState(null);
  const [status, setStatus] = useState("");
  const [mandatory, setMandatory] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [reloadData, setReloadData] = useState(false);

  const [service, setService] = useState("");
  // Ensure options are initialized as arrays

  const [typeOptions, setTypeOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const handleOpen = (item) => {
    setJsonData(item);
    setIsModelOpen((cur) => !cur);
  };
  const handleClose = () => {
    setIsModelOpen(false);
    setJsonData(null);
  };

  useEffect(() => {
    getInventoryAwsData(
      refreshToken,
      searchBy,
      sortBy,
      limit,
      page,
      "",
      "",
      "compute"
    ).then((data) => {
      setIsLoading(true);

      if (data?.code === 403) {
        navigate("/403");
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      }
      if (data?.code === 440)
        toast.error(data?.message, {
          className: "text-[12px]",
        });
      setTotalPage(data?.data?.totalPages);
      setTemplateData(data?.data);
      const dataservice = _.map(
        _.filter(
          _.keys(data?.data[0]["us-east-1"]),
          (key) => key !== "accountId"
        ),
        (key) => ({
          value: key,
          label: _.capitalize(key),
          data: data?.data[0][key],
        })
      );

      setServiceOptions(dataservice);
      if (dataservice.length > 0) {
        setService("ec2");
      }
      setIsLoading(false);
    });
  }, [page, limit, sortBy, searchBy, status, mandatory, reloadData]);

  return (
    <>
      <div className="app-main__inner !pl-20 ">
        <Card
          className="h-full w-full rounded-3xl shadow-xl"
          style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
        >
          <CardHeader
            floated={false}
            shadow={false}
            className=" bg-transparent rounded-none !overflow-visible"
          >
            <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
              <div>
                <Typography variant="h5" color="blue-gray">
                  List of AWS {activeTab === "AWSEC2" ? "EC2 " : "Lambda"}
                </Typography>
                <Typography color="gray" className="mt-1 font-normal">
                  View all compliance trainings
                </Typography>
              </div>
            </div>
            <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
                <Select
                  color="blue"
                  className="!border-t-0 !border-[#b0bec5]"
                  label="Select Limit"
                  onChange={(event) => {
                    setLimit(event);
                    setIsLoading(null);
                  }}
                  value={limit}
                >
                  <Option value={10}>10</Option>
                  <Option value={20}>20</Option>
                  <Option value={30}>30</Option>
                  <Option value={40}>40</Option>
                  <Option value={50}>50</Option>
                </Select>
                <Select
                  color="purple"
                  className="!border-t-0 !border-[#b0bec5]"
                  label="Sort By"
                  value={sortBy}
                  onChange={(event) => {
                    setSortBy(event);
                    setIsLoading(null);
                  }}
                >
                  <Option value="asc">Ascending</Option>
                  <Option value="desc">Descending</Option>
                </Select>

                {/* <Select
                color="grey"
                className="!border-t-0 !border-[#b0bec5]"
                label="Type"
                value={service}
                onChange={(event) => setService(event)}
              >
                {serviceOptions.map((opt) => (
                  <Option key={opt.value} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select> */}

                {/* Second Dropdown: Services */}
                {/* {serviceOptions.length > 0 && (
                <Select
                  color="blue"
                  className="!border-t-0 !border-[#b0bec5]"
                  label="Services"
                  value={service}
                  onChange={(event) => {
                    setService(event);
                    const ec2Option = _.find(
                      serviceOptions,
                      (item) => item.value === event
                    );
                    const dataType = _.map(
                      _.filter(_.keys(ec2Option?.data)),
                      (key) => ({
                        value: key,
                        label: _.capitalize(key),
                      })
                    );
                    setTypeOptions(dataType);
                  }}
                >
                  {serviceOptions.map((opt) => (
                    <Option key={opt.value} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              )} */}
              </div>
              {/* <div className="w-full md:w-auto">
              <Input
                label="Search"
                className="focus:!border-black focus:!border-2 focus:!border-t-0"
                value={searchBy}
                onChange={(e) => setSearchBy(e.target.value)}
                icon={<MagnifyingGlassIcon className="h-5 w-5" />}
              />
            </div> */}
            </div>
          </CardHeader>

          {service === "ec2" ? (
            <>
              {" "}
              <CardBody className="overflow-scroll px-3 p-0">
                <table className="mt-4 w-full min-w-max table-auto text-left">
                  <thead>
                    <tr>
                      {TABLE_HEAD.map((head, index) => (
                        <th
                          key={head}
                          className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-36"
                        >
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                          >
                            {head}{" "}
                            {index !== TABLE_HEAD.length - 1 && (
                              <ChevronUpDownIcon
                                strokeWidth={2}
                                className="h-4 w-4"
                              />
                            )}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading === null ? (
                      <tr>
                        <td colSpan={TABLE_HEAD.length}>
                          <TableSkeleton />
                        </td>
                      </tr>
                    ) : isLoading === false && templateData?.length > 0 ? (
                      templateData.map((item, index) => {
                        if (!item) return null;
                        const accountId = item["accountId"];
                        const { _id, ec2 } = item["us-east-1"];
                        const isLast = index === templateData.length - 1;
                        const classes = isLast
                          ? "p-3"
                          : "p-3 border-b border-blue-gray-50";

                        return (
                          <React.Fragment key={`${_id}-${index}`}>
                            {ec2 &&
                              Object.keys(ec2).map((ec2Key, keyIndex) => {
                                const ec2KeyData = ec2[ec2Key];

                                if (
                                  !ec2KeyData ||
                                  typeof ec2KeyData !== "object"
                                )
                                  return null;

                                const nestedKeys = Object.keys(ec2KeyData);

                                return nestedKeys.map(
                                  (nestedKey, nestedIndex) => {
                                    const nestedData = ec2KeyData[nestedKey];

                                    return (
                                      <tr
                                        key={`${_id}-${keyIndex}-${nestedIndex}`}
                                      >
                                        {/* Account ID */}
                                        <td className={classes}>
                                          <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal capitalize"
                                          >
                                            {accountId}
                                          </Typography>
                                        </td>

                                        {/* EC2 Key (e.g., volumes, snapshots) */}
                                        <td className={classes}>
                                          <div className="w-max">
                                            <Chip
                                              variant="outlined"
                                              className={`py-1.5 ${
                                                ec2Key === "volumes"
                                                  ? "!border-blue-500 !text-blue-600"
                                                  : ec2Key === "snapshots"
                                                  ? "!border-green-500 !text-green-600"
                                                  : ec2Key === "dhcpoptions"
                                                  ? "!border-orange-500 !text-orange-600"
                                                  : ec2Key === "networkacls"
                                                  ? "!border-purple-500 !text-purple-600"
                                                  : "!border-gray-500 !text-gray-600" // Default style for unknown keys
                                              }`}
                                              icon={
                                                ec2Key === "volumes" ? (
                                                  <PolicyIcon className="p-[2px]" />
                                                ) : ec2Key === "snapshots" ? (
                                                  <PersonIcon className="p-[2px]" />
                                                ) : ec2Key === "dhcpoptions" ? (
                                                  <ManageAccountsSharpIcon className="p-[2px]" />
                                                ) : ec2Key === "networkacls" ? (
                                                  <GroupsIcon className="p-[2px]" />
                                                ) : (
                                                  <InfoIcon className="p-[2px]" /> // Default icon for unknown keys
                                                )
                                              }
                                              value={
                                                ec2Key === "volumes"
                                                  ? "Volumes"
                                                  : ec2Key === "snapshots"
                                                  ? "Snapshots"
                                                  : ec2Key === "dhcpoptions"
                                                  ? "DHCP Options"
                                                  : ec2Key === "networkacls"
                                                  ? "Network ACLS"
                                                  : ec2Key === "instances"
                                                  ? "Instances"
                                                  : "Unknown" // Default label for unknown keys
                                              }
                                            />
                                          </div>
                                        </td>
                                        {/* Nested Key */}
                                        <td className={classes}>
                                          <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal capitalize"
                                          >
                                            {nestedKey.charAt(0).toUpperCase() +
                                              nestedKey.slice(1)}
                                          </Typography>
                                        </td>

                                        {/* Region Key */}
                                        <td className={classes}>
                                          <Typography
                                            variant="small"
                                            color="blue-gray"
                                            className="font-normal capitalize"
                                          >
                                            {nestedData?.region ||
                                              "No Region Data"}
                                          </Typography>
                                        </td>
                                        <td className={classes}>
                                          <Tooltip
                                            content="View Policy"
                                            className="bg-blue-gray-500"
                                          >
                                            <Button
                                              variant="gradient"
                                              size="sm"
                                              onClick={() =>
                                                handleOpen(
                                                  nestedData?.responseElements
                                                )
                                              }
                                            >
                                              <span>Policies</span>
                                            </Button>
                                          </Tooltip>
                                        </td>
                                      </tr>
                                    );
                                  }
                                );
                              })}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8">
                          <div className="flex flex-col items-center w-full">
                            <img
                              height={250}
                              width={250}
                              quality={100}
                              src="/assets/images/no-data-found.png"
                              className="w-1/4 mix-blend-darken"
                              alt="No Data Found"
                            />
                            <p className="text-[18px] font-extralight">
                              No Data Found!
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </CardBody>
            </>
          ) : null}
          {service === "lambda" ? (
            <>
              <CardBody className="overflow-scroll px-3 p-0">
                <table className="mt-4 w-full min-w-max table-auto text-left">
                  <thead>
                    <tr>
                      {LAMBDA_TABLE_HEAD.map((head, index) => (
                        <th
                          key={head}
                          className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-3 transition-colors hover:bg-blue-gray-50 w-36"
                        >
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="flex items-center justify-between gap-2 font-bold leading-none opacity-70"
                          >
                            {head}{" "}
                            {index !== LAMBDA_TABLE_HEAD.length - 1 && (
                              <ChevronUpDownIcon
                                strokeWidth={2}
                                className="h-4 w-4"
                              />
                            )}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading === null ? (
                      <tr>
                        <td colSpan={LAMBDA_TABLE_HEAD.length}>
                          <TableSkeleton />
                        </td>
                      </tr>
                    ) : isLoading === false && templateData?.length > 0 ? (
                      templateData.map((item, index) => {
                        if (!item) return null;

                        const { _id, accountId, lambda } = item;
                        const isLast = index === templateData.length - 1;
                        const classes = isLast
                          ? "p-3"
                          : "p-3 border-b border-blue-gray-50";

                        return (
                          <React.Fragment key={`${_id}-${index}`}>
                            {lambda &&
                              Object.keys(lambda).map((ec2Key, keyIndex) => {
                                const ec2KeyData = lambda[ec2Key];

                                if (
                                  !ec2KeyData ||
                                  typeof ec2KeyData !== "object"
                                )
                                  return null;

                                const nestedKeys = Object.keys(ec2KeyData);

                                return (
                                  <tr key={`${_id}-${keyIndex}-${keyIndex}`}>
                                    {/* Account ID */}
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal capitalize"
                                      >
                                        {accountId}
                                      </Typography>
                                    </td>

                                    {/* EC2 Key (e.g., volumes, snapshots) */}
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal capitalize"
                                      >
                                        {ec2Key.charAt(0).toUpperCase() +
                                          ec2Key.slice(1)}
                                      </Typography>
                                    </td>

                                    {/* Region Key */}
                                    <td className={classes}>
                                      <Typography
                                        variant="small"
                                        color="blue-gray"
                                        className="font-normal capitalize"
                                      >
                                        {ec2KeyData?.region || "No Region Data"}
                                      </Typography>
                                    </td>
                                    <td className={classes}>
                                      <Tooltip
                                        content="View Policy"
                                        className="bg-blue-gray-500"
                                      >
                                        <Button
                                          variant="gradient"
                                          size="sm"
                                          onClick={() =>
                                            handleOpen(
                                              ec2KeyData?.responseElements
                                            )
                                          }
                                        >
                                          <span>Policies</span>
                                        </Button>
                                      </Tooltip>
                                    </td>
                                  </tr>
                                );
                              })}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8">
                          <div className="flex flex-col items-center w-full">
                            <img
                              height={250}
                              width={250}
                              quality={100}
                              src="/assets/images/no-data-found.png"
                              className="w-1/4 mix-blend-darken"
                              alt="No Data Found"
                            />
                            <p className="text-[18px] font-extralight">
                              No Data Found!
                            </p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </CardBody>
            </>
          ) : null}
        </Card>
      </div>
      {/* Dialog for JSON Viewer */}
      <Dialog
        open={isModelOpen}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
          EC2 Data
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          {jsonData ? (
            <ReactJson
              src={jsonData}
              theme="monokai"
              displayDataTypes={false}
              displayObjectSize={false}
              indentWidth={4}
              name={false}
              collapsed={true}
            />
          ) : (
            <p>No Data Available</p>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
